import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { SharedModule } from '../_shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatExpansionModule, MatTreeModule } from '@angular/material';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  RetentionOffersComponent,
  RetentionStagePopupComponent,
  SegmentsComponent,
  StageDetailsComponent,
  SurveyStepsComponent,
  SegmentConditionsPopupComponent,
  UserSurveyPopup,
  StageSettingsComponent,
  RetentionSettingsComponent,
  SingleStepPathComponent,
  OfferStepCardComponent,
} from '.';
import { OfferBuilderRoutingModule } from './offer-builder.routing';
import { StepsLibraryModule } from '../steps-library/steps-library.module';

@NgModule({
  declarations: [
    RetentionOffersComponent,
    SegmentsComponent,
    RetentionStagePopupComponent,
    StageDetailsComponent,
    SurveyStepsComponent,
    UserSurveyPopup,
    SegmentConditionsPopupComponent,
    StageSettingsComponent,
    RetentionSettingsComponent,
    SingleStepPathComponent,
    OfferStepCardComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    OfferBuilderRoutingModule,
    StepsLibraryModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    SharedModule,
    NgbModule,
    MatExpansionModule,
    MatTreeModule,
    DragDropModule,
    NgxSmartModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
  ],
  providers: [],
  bootstrap: [],
})
export class OfferBuilderModule {}
